function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*------------------------------------------------------------------
Import external modules
------------------------------------------------------------------*/

import Equalizer from '@meteora-digital/equalizer';

/*------------------------------------------------------------------
Equal Heights
------------------------------------------------------------------*/

window.equalizers = {};
window.equalize = function () {
  for (var key in window.equalizers) {
    if (Object.hasOwnProperty.call(window.equalizers, key)) {
      window.equalizers[key].update();
      window.equalizers[key].resize();
    }
  }
};
var index = 0;
_toConsumableArray(document.querySelectorAll('[data-equalize]')).forEach(function (container) {
  var id = container.getAttribute('data-equalize');
  window.equalizers[id || index] = new Equalizer({
    container: container,
    identifiers: id,
    rows: false
  });
  index += 1;
});
_toConsumableArray(document.querySelectorAll('[data-eqrows]')).forEach(function (container) {
  var id = container.getAttribute('data-eqrows');
  window.equalizers[id || index] = new Equalizer({
    container: container,
    identifiers: id,
    rows: true
  });
  index += 1;
});